import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface LeftAsideStore {
  isHidden: boolean;
  setIsHidden: (isHidden: boolean) => void;
  toggle: () => void;
}

export const useLeftSidebarStore = create<LeftAsideStore>()(
  persist(
    (set) => ({
      isHidden: false,
      setIsHidden: (isHidden: boolean) => set({ isHidden }),
      toggle: () => set((state) => ({ isHidden: !state.isHidden })),
    }),
    { name: "left-sidebar-state", storage: createJSONStorage(() => localStorage) },
  ),
);
